import moment from 'moment';
import { TransactionsAction, TransactionsActionTypes, TransactionsState } from './transactionsTypes';

const initialState: TransactionsState = {
  loadingTransactions: true,
  savingTransaction: false,
  removingTransaction: false,
  transactions: [],
  resume: null,
  selectedIndex: null,
  isEditing: false,
  resumeDay: null,
  loadingResume: false,
  filters: {
    dateFrom: moment().startOf('year').format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD'),
    type: 'all',
    resource: 'all',
    category: 'all',
  },
};

export default function transactionsReducer(
  state = initialState,
  action: TransactionsAction,
): TransactionsState {
  switch (action.type) {
    case TransactionsActionTypes.EDITING_START:
      return {
        ...state,
        isEditing: true,
        selectedIndex: action.index ?? null,
      };

    case TransactionsActionTypes.EDITING_CANCEL:
      return {
        ...state,
        isEditing: false,
      };

    case TransactionsActionTypes.GET_TRANSACTIONS_START:
      return {
        ...state,
        loadingTransactions: true,
      };

    case TransactionsActionTypes.GET_TRANSACTIONS_SUCCESS:
      if (!action.transactions) {
        throw new Error();
      }
      return {
        ...state,
        loadingTransactions: false,
        transactions: action.transactions,
      };

    case TransactionsActionTypes.GET_TRANSACTIONS_ERROR:
      return {
        ...state,
        loadingTransactions: false,
      };

    case TransactionsActionTypes.SAVE_TRANSACTION_START:
      return {
        ...state,
        savingTransaction: true,
      };

    case TransactionsActionTypes.SAVE_TRANSACTION_SUCCESS:
      return {
        ...state,
        savingTransaction: false,
        selectedIndex: null,
        // isEditing: false,
      };

    case TransactionsActionTypes.SAVE_TRANSACTION_ERROR:
      return {
        ...state,
        savingTransaction: false,
      };

    case TransactionsActionTypes.GET_RESUME_DAY_START:
      return {
        ...state,
        loadingResume: true,
        resumeDay: null,
      };

    case TransactionsActionTypes.GET_RESUME_DAY_SUCCESS:
      if (!action.resumeDay) {
        throw new Error();
      }
      return {
        ...state,
        loadingResume: false,
        resumeDay: action.resumeDay,
      };

    case TransactionsActionTypes.GET_RESUME_DAY_ERROR:
      return {
        ...state,
        loadingResume: false,
        resumeDay: null,
      };

    case TransactionsActionTypes.GET_RESUME_YEAR_START:
      return {
        ...state,
        loadingResume: true,
        resume: null,
      };

    case TransactionsActionTypes.GET_RESUME_YEAR_SUCCESS:
      if (!action.resume) {
        throw new Error();
      }
      return {
        ...state,
        loadingResume: false,
        resume: action.resume,
      };

    case TransactionsActionTypes.GET_RESUME_YEAR_ERROR:
      return {
        ...state,
        loadingResume: false,
        resume: null,
      };

    case TransactionsActionTypes.SET_TRANSACTIONS_FILTERS:
      if (!action.filters) {
        throw new Error();
      }
      return {
        ...state,
        filters: action.filters,
      };

    case TransactionsActionTypes.CLEAR:
      return initialState;

    default:
      return state;
  }
}
